export default __webpack_public_path__ + "static/media/ASCWHITEPAPER.05324466.pdf";